export var TicketRedemptionCardType;
(function(TicketRedemptionCardType) {
    TicketRedemptionCardType[/**
     * A card belonging to a [[Member]] with a [[Subscription]].
     */ "MemberSubscriptionCard"] = "MemberSubscriptionCard";
    TicketRedemptionCardType[/**
     * A card belonging to a member of a [[ThirdPartyMemberScheme]].
     */ "ThirdPartyMemberCard"] = "ThirdPartyMemberCard";
})(TicketRedemptionCardType || (TicketRedemptionCardType = {}));

//# sourceMappingURL=ticket-redemption-card-type.js.map